/**
 * Minified by jsDelivr using Terser v3.14.1.
 * Original file: /npm/moment@2.27.0/moment.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
